
	<div
		class="form-group"
		[formGroup]="OBJ_form_group"
		[ngClass]="{'has-error': isInvalid()}">
		<ng-template #tooltipTemplate><div [innerHtml]="getHint()|translate"></div></ng-template>
		<label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
			<i *ngIf="getHint()" class="fa fa-info-circle tig-tooltip-icon"
				[tooltip]="tooltipTemplate"
				placement="top"
				triggers="click"
				containerClass="tig-tooltip"
				delay="50"></i>
            <span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
		<div class="col-lg-8">
			<ng-select
				[formControlName]="OBJ_field_config.name"
				[items]="OBJ_field_config.options"
				[multiple]="(OBJ_field_config.multiple != null)?OBJ_field_config.multiple:true"
				[disabled]="OBJ_field_config?.readonly"
				(selected)="selected($event)"
				(removed)="removed($event)"
				(data)="refreshValue($event)"
				[placeholder]="'please_select'|translate"
				[allowClear]="true"
			></ng-select>
            <div *ngIf="STR_dependent_fields">{{ "oSelect.swarning_dependent_fields"|translate:{value:this.STR_dependent_fields} }}</div>
			<div class="tig-hint" *ngIf="OBJ_field_config.note">
				<span>{{ OBJ_field_config.note|translate}}</span>
			</div>
            <tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
		</div>
	</div>
	